import { Stack } from "@similarweb/ui-components/foundations";

import CellDefaultTooltip from "../CellDefaultTooltip/CellDefaultTooltip";

import CountryGroupCell from "./CountryGroupCell/CountryGroupCell";
import FallbackLocationCell from "./FallbackLocationCell";
import LocationCell from "./LocationCell";

type Props = { locationCodes: readonly number[]; recordIndex: number };

const LocationGroupCell = ({ locationCodes, recordIndex }: Props) => {
    if (locationCodes.length === 0) {
        return <FallbackLocationCell />;
    }

    if (locationCodes.length === 1) {
        return <LocationCell locationCode={locationCodes[0]} />;
    }

    return (
        <CellDefaultTooltip
            theme="light"
            content={
                <Stack gap="8px">
                    {locationCodes.map((countryCode) => (
                        <LocationCell
                            key={countryCode}
                            locationCode={countryCode}
                        />
                    ))}
                </Stack>
            }
        >
            <CountryGroupCell
                countryCodes={locationCodes}
                recordIndex={recordIndex}
            />
        </CellDefaultTooltip>
    );
};

export default LocationGroupCell;
